// extracted by mini-css-extract-plugin
module.exports = {"container":"Highlight_container__35JUJ","highlight":"Highlight_highlight__15mri","highlight-section":"Highlight_highlight-section__gUOZx"};